//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
import "../no/SelectDisplayableObject.js";
import "../no/SelectObject.js";
let d=[[[0,"AsRequiredText",1,0],[0,"AttributeName",1,0],[0,"Category",1,0],[0,"DefaultText",1,0],[0,"IncludeNestedAssemblies",1,0],[0,"KeyField",1,0],[0,"NestedAssemblyQuantity",1,0],[0,"ParentAssemblyQuantity",1,0],[0,"ProtectCells",1,0],[0,"Scope",1,0],[1,"SelectParentComponent",0,"SelectDisplayableObject",0],[0,"ShowCombinedMassForAssemblies",1,0],[0,"Title",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.TableColumnBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.TableColumnBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.TableColumnBuilder.CategoryType = Object.freeze({
    "General" : "General", "Callout" : "Callout", "Quantity" : "Quantity"});

SPLM.Annotations.TableColumnBuilder.ScopeType = Object.freeze({
    "CellsinNewRows" : "CellsinNewRows", "AllCellsinColumn" : "AllCellsinColumn"});

export default SPLM;